module.exports = require("core-js-pure/stable/instance/map");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/map.js
// module id = 37
// module chunks = 0 1